import type { Locale } from "../types.js";
import { en } from "./en.js";
import { fa } from "./fa.js";

/**
 * Typed locale bundles. `en` is the shape; `fa` is declared AS that shape, so
 * a missing Persian key is a compile error, not a runtime gap. Both halves of
 * the site import from here — the server for emails and OG descriptions, the
 * app for everything on screen.
 */
/** Literal string types from `as const` widened to `string`, structure preserved. */
type Widen<T> = T extends string ? string : { readonly [K in keyof T]: Widen<T[K]> };
export type Messages = Widen<typeof en>;
export const MESSAGES: Record<Locale, Messages> = { en, fa };

export function messagesFor(locale: Locale): Messages {
  return MESSAGES[locale];
}

/** `{name}` placeholder substitution; unknown placeholders are left visible so they get noticed. */
export function interpolate(template: string, vars: Record<string, string | number> = {}): string {
  return template.replace(/\{(\w+)\}/g, (m, key: string) =>
    key in vars ? String(vars[key]) : m,
  );
}

export function dirFor(locale: Locale): "ltr" | "rtl" {
  return locale === "fa" ? "rtl" : "ltr";
}

export function ogLocaleFor(locale: Locale): string {
  return locale === "fa" ? "fa_IR" : "en_GB";
}

export { en, fa };
